import { render, staticRenderFns } from "./EmbeddedDashboard.vue?vue&type=template&id=1fd2930b&scoped=true&"
import script from "./EmbeddedDashboard.vue?vue&type=script&lang=js&"
export * from "./EmbeddedDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd2930b",
  null
  
)

export default component.exports